import { EVENT_KINDS, VENUE_TYPES, byId } from "../../shared/knowledge";
import type { Project } from "../../shared/types";
import { icon } from "../icons";
import { api, busy, chipGroup, emptyState, fmtDay, h, mediaUrl, modal } from "../lib";
import { go } from "../store";
import { flowTrio } from "./showcase";

type Item = { id: string; title: string; updatedAt: string; brief: any; cover: string | null; cuts: number };

export async function renderProjects(main: HTMLElement) {
  const list = await api<Item[]>("/api/projects");
  if (!list.length) {
    const empty = emptyState({
      icon: "grid",
      title: "첫 무대를 세워 볼까요?",
      body: "장소를 정하고, 무대 시안을 고르고, 연출컷을 뽑아요",
      action: h("button", { class: "btn primary large", type: "button", onclick: () => newProject() }, icon("plus"), "새 프로젝트"),
    });
    // 무엇을 하는 앱인지 그림으로: 같은 장소의 3D 기준 → 1차 무대 시안 → 2차 연출컷 (작게, 늦게 받는다)
    empty.append(flowTrio({ title: "이렇게 세워져요", compact: true }));
    main.append(h("div", { class: "page-head" }, h("h1", null, "내 프로젝트")), empty);
    return;
  }
  main.append(
    h(
      "div",
      { class: "page-head" },
      h("h1", null, "내 프로젝트", h("span", { class: "count num" }, String(list.length))),
      h("button", { class: "btn primary", type: "button", onclick: () => newProject() }, icon("plus"), "새 프로젝트"),
    ),
    h(
      "div",
      { class: "project-grid" },
      list.map((p) =>
        h(
          "a",
          { class: "card project-card", href: `#/p/${p.id}` },
          h("div", { class: "thumb" }, p.cover ? h("img", { src: mediaUrl(p.cover), alt: "", loading: "lazy" }) : h("span", { class: "thumb-empty" }, icon("image", 24), h("span", { class: "xs" }, "아직 그림이 없어요"))),
          h(
            "div",
            { class: "project-body" },
            h("h3", { class: "two-line" }, p.title),
            h("p", { class: "small muted one-line" }, [byId(EVENT_KINDS, p.brief?.eventKind)?.ko, byId(VENUE_TYPES, p.brief?.venueType)?.ko || p.brief?.eventType].filter(Boolean).join(" · ") || "장소를 아직 안 정했어요"),
            h("p", { class: "xs muted num project-foot" }, h("span", null, `그림 ${p.cuts}장`), h("span", null, fmtDay(p.updatedAt))),
          ),
        ),
      ),
    ),
  );
}

function newProject() {
  const name = h("input", { placeholder: "예: 2027 충청 유니버시아드 개회식", maxlength: 120, id: "new-project-name" });
  let kind = "";
  const kinds = chipGroup(EVENT_KINDS, [], false, (v) => (kind = v[0] || ""), "어떤 행사인가요");
  const btn = h("button", { class: "btn primary", type: "submit", form: "new-project-form" }, "만들기");
  const close = modal(
    "새 프로젝트",
    h(
      "form",
      {
        class: "stack",
        id: "new-project-form",
        onsubmit: async (e: Event) => {
          e.preventDefault();
          await busy(btn, "만드는 중", async () => {
            if (!name.value.trim()) throw new Error("행사 이름을 적어 주세요.");
            const p = await api<Project>("/api/projects", { body: { eventName: name.value, eventKind: kind || undefined, venueMode: "virtual" } });
            close();
            go(`#/p/${p.id}/info`);
          });
        },
      },
      h("label", null, "행사 이름", name),
      h("div", { class: "field" }, h("span", { class: "field-label" }, "어떤 행사인가요 ", h("span", { class: "opt" }, "(선택)")), kinds),
    ),
    { size: "sm", sub: "다음 화면에서 장소와 규모를 정해요", foot: (cl) => [h("button", { class: "btn ghost", type: "button", onclick: cl }, "취소"), btn] },
  );
}
